module.exports = __webpack_public_path__ + "static/ae-f7d1ae806f3828a97551be31313f769b.svg";